import { render, staticRenderFns } from "./QuestionPage.vue?vue&type=template&id=6e3d3ae5&scoped=true&"
import script from "./QuestionPage.vue?vue&type=script&lang=js&"
export * from "./QuestionPage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPage.vue?vue&type=style&index=0&id=6e3d3ae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3d3ae5",
  null
  
)

export default component.exports